import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { routeNaming, AppRedirect } from '../../../routes';
import { enforceMenus } from '../../../hocs/enforce-menus';
import { Spinner } from '../../../common/spinner';
import { ProductCard } from '../../../common/product-card';
import { CategoryProductsStore } from '../stores/CategoryProductsStore';
import { CategoryBanner } from '../category-banner';
import styles from './MainBody.css';
import { enforceParameters } from '../../../hocs/enforce-parameters';
import { SEO } from '../../../common/seo/Seo';

const IPropTypes = {
  groupId: PropTypes.string.isRequired,
};

const defaultProps = {
};

const renderRedirect = () => (
  <AppRedirect
    routeName={routeNaming.NOT_FOUND}
  />
);

class MainBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    CategoryProductsStore.fetchProductsForGroup(this.props.groupId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.groupId !== this.props.groupId) {
      CategoryProductsStore.fetchProductsForGroup(this.props.groupId);
    }
  }

  render() {
    const { products, group, error } = CategoryProductsStore;

    if (error) {
      return renderRedirect();
    }

    const texts = group ? group.description.split('+++') : [];

    return (
      <div>
        {
          group && group.image &&
          <SEO
            title={group.name}
            description={group.description}
            type="category"
            image={group.image}
            keyword={group.name}
          />
        }
        {
          group && group.image &&
          <CategoryBanner
            imageSrc={group.image}
            text={group.name}
            textColor={group.nameColor}
          />
        }
        <div className={[styles.container].join(' ')}>
          {texts.length > 1 &&
            <div style={{ marginTop: 20, marginBottom: 50 }}>
              <h2 style={{ textAlign: 'center', marginTop: 0 }}>{texts[0]}</h2>
              <div style={{ textAlign: 'center' }} className={styles.html_desc} dangerouslySetInnerHTML={{ __html: texts[1] }} />
            </div>
          }
          {
            products === null
            ? <Spinner className={styles.spinner} imgClassName={styles.spinnerImage} />
            : (
              <div className={styles.productList}>
                {products.map(product => (
                  <ProductCard
                    className={styles.productCard}
                    key={product.id}
                    product={product}
                  />
                ))}
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

MainBody.propTypes = IPropTypes;
MainBody.defaultProps = defaultProps;

const WrappedMainBody = enforceParameters(enforceMenus(observer(MainBody)));

export { WrappedMainBody as MainBody };



// WEBPACK FOOTER //
// ./src/pages/product-group/main-body/MainBody.jsx